import { useEffect } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';

import * as server from '../server';
import { useParams } from './useParams';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFetchComponent = () => {
    const params = useParams();
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const getErrorMessage = useGetErrorMessage();

    useEffect(() => {
        if (!isMounted()) {
            return;
        }

        const { product } = params;

        if (!product) {
            // since initially product is set according to component config
            // we need to skip all the states when the product is not yet set
            return;
        }

        dispatch(actions.toggleLoading(true));
        dispatch(actions.setData({ error: '' }));

        (async () => {
            try {
                const response = await server.getGameHistory(params);
                const { totalRecords, results: history } = response.data;

                isMounted() && dispatch(actions.setData({ totalRecords, history }));
            } catch (error) {
                const errorMsg = getErrorMessage(error);

                isMounted() && dispatch(actions.setData({ error: errorMsg }));

            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [dispatch, isMounted, params, getErrorMessage]);
};
